import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const styles = (theme) => ({
    root: {
    },
});

const WindInfoTableView = (props) => {
    const { t, classes, fields, list } = props;

    useEffect(() => {
        
    }, []);

    return (
        <>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell>風場合約 (Wind Contract)</TableCell>
                    {fields.map(field => (
                        <TableCell key={field.field_code}>{field.name}</TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                {list.map(item => (
                    <TableRow key={item.windcontract_id}>
                    <TableCell>{item.windfield_simplename}</TableCell>
                    {fields.map(field => (
                        <TableCell key={field.field_code}>
                            {item.fields ? item.fields.find(f => f.field_code === field.field_code)?.value || '-' : '-'}
                        </TableCell>
                    ))}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </>
    );    
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(WindInfoTableView);
